module.exports = __webpack_public_path__ + "img/@img_jisike_04.02b23e57.jpg";